import { DTO } from "./database";
import { fieldsModel } from '../models/field';


const collection = "farms";
class FarmModel extends DTO {
  constructor(collection) {
    super(collection);
  }

  getFarmData(id){
    const data = {};
    return this.get(id).then(farm => {
      data.farm = farm;
      return fieldsModel.getFields(id);
    }).then((fields) => {
      data.fields = fields;
      data.services = fieldsModel.getAllFieldServices(fields);
      return data;
    });
  }
}

export const farmsModel = new FarmModel(collection);
